(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nulterra-explore"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      let products = [], labels = {};
      try { products = JSON.parse(root.querySelector('[data-explore-catalog]').textContent); labels = JSON.parse(root.querySelector('[data-explore-labels]').textContent); } catch { return; }
      const createCard = p => {
        const fragment = root.querySelector('[data-product-template]').content.cloneNode(true);
        fragment.querySelectorAll('a').forEach(a => a.href = p.url);
        const image = fragment.querySelector('img'); image.src = p.image; image.alt = p.alt;
        fragment.querySelector('[data-product-title]').textContent = p.title;
        fragment.querySelector('[data-product-price]').textContent = (p.varies ? labels.from + ' ' : '') + p.price;
        return fragment;
      };
      const form = root.querySelector('[data-quiz]'), steps = [...form.querySelectorAll('[data-step]')], back = form.querySelector('[data-quiz-back]'), next = form.querySelector('[data-quiz-next]');
      const results = root.querySelector('[data-quiz-results]'); let current = 0;
      const showStep = () => { steps.forEach((el,i) => { el.hidden = i !== current; }); back.hidden = current === 0; next.textContent = current === 2 ? labels.reveal : labels.next; next.disabled = !steps[current].querySelector('input:checked'); form.querySelector('[data-quiz-progress]').textContent = labels.step.replace('{number}', current + 1); };
      form.querySelector('[data-quiz-controls]').hidden = false; showStep();
      form.addEventListener('change', showStep); back.addEventListener('click', () => { current = Math.max(0,current - 1); showStep(); });
      const matchesType = (p, t) => t === 'hoodie' ? /hoodie/i.test(p.type + ' ' + p.title) : t === 'sweatshirt' ? /sweatshirt/i.test(p.type + ' ' + p.title) : /t[ -]?shirt/i.test(p.type + ' ' + p.title);
      const isSubtle = p => /core-logo|off-the-radar|unknown-profile|alien-echo|ufo-signal/.test(p.handle);
      const matchesSignal = (p,s) => s === 'bigfoot' ? /bigfoot|sasquatch/.test(p.tags + '|' + p.handle) : s === 'aliens' ? /alien/.test(p.tags + '|' + p.handle) && !/bigfoot/.test(p.handle) : /ufo|unzipped|radar|stairway|first-contact/.test(p.tags + '|' + p.handle);
      const reveal = () => {
        const values = Object.fromEntries(new FormData(form));
        if (!values.signal || !values.style || !values.type) return;
        const candidates = products.filter(p => matchesType(p,values.type)).map(p => ({p,score:(matchesSignal(p,values.signal) ? 4 : 0) + ((values.style === 'subtle') === isSubtle(p) ? 2 : 0)})).sort((a,b) => b.score-a.score);
        const exact = candidates.filter(x => x.score === 6); const selected = exact.length ? exact.slice(0,3) : candidates.filter(x => x.score === (candidates[0]?.score || 0)).slice(0,3);
        const cards = root.querySelector('[data-quiz-cards]'); cards.replaceChildren(); selected.forEach(x => cards.append(createCard(x.p)));
        root.querySelector('[data-quiz-result-note]').textContent = selected.length ? (exact.length ? labels.matches : labels.closest) : labels.no_products;
        form.hidden = true; results.hidden = false; results.focus();
      };
      next.addEventListener('click', () => { if (!steps[current].querySelector('input:checked')) return; if (current < 2) { current++; showStep(); steps[current].querySelector('input').focus(); } else reveal(); });
      form.addEventListener('submit', e => { e.preventDefault(); if (current < 2) next.click(); else reveal(); });
      root.querySelector('[data-quiz-restart]').addEventListener('click', () => { form.reset(); current=0; results.hidden=true; form.hidden=false; showStep(); steps[0].querySelector('input').focus(); });
      let bag = [], lastId = null;
      root.querySelector('[data-surprise]').addEventListener('click', e => {
        if (!products.length) { root.querySelector('[data-surprise-card]').textContent=labels.no_products; return; }
        if (!bag.length) { bag = [...products]; for(let i=bag.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[bag[i],bag[j]]=[bag[j],bag[i]];} if (bag.length>1 && bag[bag.length-1].id===lastId) [bag[0],bag[bag.length-1]]=[bag[bag.length-1],bag[0]]; }
        const p=bag.pop();lastId=p.id;root.querySelector('[data-surprise-card]').replaceChildren(createCard(p));root.querySelector('[data-surprise-status]').textContent=p.title;e.currentTarget.textContent=labels.another;
      });
      const openTarget = hash => { if (!hash) return; let id;try{id=decodeURIComponent(hash.slice(1));}catch{return;}const target=document.getElementById(id);if(!target)return;const details=target.matches('details')?target:target.closest('details');if(details)details.open=true; };
      openTarget(location.hash); window.addEventListener('hashchange',()=>openTarget(location.hash));
      document.querySelectorAll('[data-explore-shortcut]').forEach(a=>a.addEventListener('click',()=>openTarget(a.hash)));
      root.querySelectorAll('[data-contact-result]').forEach(result=>{const target=result.closest('form');if(location.hash==='#'+target.id)target.closest('details').open=true;else result.hidden=true;});
      window.dispatchEvent(new CustomEvent('nulterra:explore-ready'));
    };
    const boot = () => document.querySelectorAll('[data-n-explore]').forEach(init);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
    document.addEventListener('shopify:section:load',boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nulterra-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nulterra-hero-video')) {
    customElements.define('nulterra-hero-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.video.muted = true;
        this.video.controls = false;
        this.syncPlayback = () => {
          if (document.hidden || !this.inView || this.motion.matches || navigator.connection?.saveData) {
            this.video.pause();
          } else {
            this.video.play().catch(() => {});
          }
        };
        document.addEventListener('visibilitychange', this.syncPlayback, options);
        this.motion.addEventListener('change', this.syncPlayback, options);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abort?.abort();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nulterra-studio"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=root=>{
    if(root.dataset.studioReady)return;root.dataset.studioReady='true';
    const labels=JSON.parse(root.querySelector('[data-studio-labels]').textContent),tabs=[...root.querySelectorAll('[data-studio-tab]')],panels=[...root.querySelectorAll('[data-studio-panel]')],reveal=root.querySelector('[data-studio-reveal]'),range=root.querySelector('[data-studio-range]');
    const play=root.querySelector('[data-studio-play]'),playLabel=root.querySelector('[data-studio-play-label]'),overlay=root.querySelector('[data-studio-overlay]'),timeline=root.querySelector('[data-studio-timeline]'),film=root.querySelector('[data-studio-film]'),image=root.querySelector('.n-studio__film-art img'),product=root.querySelector('[data-studio-film-product]'),caption=root.querySelector('[data-studio-caption]'),status=root.querySelector('[data-studio-status]'),media=window.matchMedia('(prefers-reduced-motion: reduce)');
    let playing=false,position=0,last=null,frame=0,scene=-1,active='reveal';
    const format=value=>'0:'+String(Math.floor(value)).padStart(2,'0');
    const showPosition=value=>{if(!range)return;const n=Math.max(0,Math.min(100,Number(value)));range.value=n;reveal.style.setProperty('--studio-split',n+'%');range.setAttribute('aria-valuetext',n===0?labels.clothing:n===100?labels.detail:labels.percentage.replace('__VALUE__',Math.round(n)));};
    if(range){range.hidden=false;root.querySelector('[data-studio-presets]').hidden=false;range.addEventListener('input',()=>showPosition(range.value));root.querySelectorAll('[data-studio-to]').forEach(button=>button.addEventListener('click',()=>showPosition(button.dataset.studioTo)));showPosition(50);}
    const pause=()=>{playing=false;cancelAnimationFrame(frame);last=null;if(!play)return;playLabel.textContent=position>=12?labels.replay:labels.play;play.setAttribute('aria-label',playLabel.textContent);overlay.hidden=position>0;status.textContent=position>=12?labels.complete:position>0?labels.paused:labels.ready;};
    const draw=()=>{if(!film)return;const t=position,step=t<3?0:t<6?1:t<9?2:3;timeline.value=t;timeline.setAttribute('aria-valuetext',labels.seconds.replace('__VALUE__',t.toFixed(1)));root.querySelector('[data-studio-time]').textContent=format(t)+' / 0:12';const motionTime=media.matches?step*3:t;image.style.objectPosition='50% '+(77-Math.min(motionTime,7)*4.4)+'%';image.style.transform=media.matches?'none':'scale('+(1.12-Math.min(motionTime,9)*.01)+')';root.querySelector('[data-studio-tint]').style.opacity=media.matches?'0':String(Math.max(0,.42-t*.055));if(product){const visible=t>=9;product.style.opacity=media.matches?(visible?'1':'0'):String(Math.min(1,Math.max(0,(t-8.6)/.7)));product.style.pointerEvents=visible?'auto':'none';product.inert=!visible;product.setAttribute('aria-hidden',String(!visible));caption.style.opacity=t>=8.6?'0':'1';caption.setAttribute('aria-hidden',String(t>=9));}if(step!==scene){scene=step;root.querySelector('[data-studio-scene-title]').textContent=labels.titles[step];root.querySelector('[data-studio-scene-copy]').textContent=labels.captions[step];if(playing)status.textContent=labels.scenes[step];}};
    const tick=now=>{if(!playing)return;if(last!==null)position=Math.min(12,position+(now-last)/1000);last=now;draw();if(position>=12){pause();return;}frame=requestAnimationFrame(tick);};
    const togglePlay=()=>{if(playing){pause();return;}if(position>=12)position=0;playing=true;last=null;scene=-1;overlay.hidden=true;playLabel.textContent=labels.pause;play.setAttribute('aria-label',labels.pause);draw();frame=requestAnimationFrame(tick);};
    if(play){root.querySelector('[data-studio-controls]').hidden=false;overlay.hidden=false;play.addEventListener('click',togglePlay);overlay.addEventListener('click',togglePlay);timeline.addEventListener('input',()=>{pause();position=Number(timeline.value);scene=-1;draw();pause();});draw();pause();media.addEventListener('change',draw);}
    const select=name=>{pause();active=name;tabs.forEach(tab=>{const selected=tab.dataset.studioTab===name;tab.setAttribute('aria-selected',String(selected));tab.tabIndex=selected?0:-1;});panels.forEach(panel=>panel.hidden=panel.dataset.studioPanel!==name);};
    tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab.dataset.studioTab));tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(tabs[next].dataset.studioTab);tabs[next].focus();});});
    root.querySelector('[data-studio-tabs]').hidden=false;panels.forEach((panel,index)=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[index].id);});select(active);
    const onVisibility=()=>{if(document.hidden&&playing)pause();};document.addEventListener('visibilitychange',onVisibility);
    let observer;if('IntersectionObserver' in window&&film){observer=new IntersectionObserver(entries=>{if(!entries[0].isIntersecting&&playing)pause();},{threshold:0.1});observer.observe(film);}
    const cleanup=event=>{if(!event.target.contains(root))return;pause();observer?.disconnect();document.removeEventListener('visibilitychange',onVisibility);media.removeEventListener('change',draw);document.removeEventListener('shopify:section:unload',cleanup);};document.addEventListener('shopify:section:unload',cleanup);
  };
  const boot=()=>document.querySelectorAll('[data-n-studio]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nulterra-wallpapers"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const init=root=>{
      if(root.dataset.ready)return;root.dataset.ready='true';
      const labels=JSON.parse(root.querySelector('[data-wallpaper-labels]').textContent),status=root.querySelector('[data-wallpaper-status]'),dialog=root.querySelector('[data-wallpaper-dialog]');
      let activeCard=null,returnFocus=null;const files=new Map();const setStatus=text=>{status.textContent=text;root.querySelector('[data-wallpaper-dialog-status]').textContent=text;};
      const prepare=card=>{const url=card.dataset.wallpaperUrl;if(!files.has(url)){const p=fetch(url,{credentials:'omit'}).then(r=>{if(!r.ok)throw new Error('Download unavailable');return r.blob();}).then(blob=>{if(!blob.type.startsWith('image/'))throw new Error('Not an image');return blob;}).catch(()=>{files.delete(url);return null;});files.set(url,p);}return files.get(url);};
      const close=()=>{dialog.close();returnFocus?.focus();};
      const download=async(card,control)=>{
        if(control.getAttribute('aria-busy')==='true')return;control.setAttribute('aria-busy','true');setStatus(labels.loading);
        try{const blob=await prepare(card);if(!blob)throw new Error('Download unavailable');const extensions={'image/png':'png','image/jpeg':'jpg','image/webp':'webp','image/avif':'avif'};const objectUrl=URL.createObjectURL(blob),a=document.createElement('a');a.href=objectUrl;a.download=card.dataset.wallpaperFilename+'.'+(extensions[blob.type]||'png');document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(objectUrl),30000);setStatus(labels.ready);}catch{setStatus(labels.error);(dialog.open?root.querySelector('[data-wallpaper-dialog-status]'):status).focus();}finally{control.removeAttribute('aria-busy');}
      };
      root.addEventListener('click',e=>{
        const preview=e.target.closest('[data-wallpaper-preview]');if(preview&&typeof dialog.showModal==='function'){e.preventDefault();activeCard=preview.closest('[data-wallpaper-card]');returnFocus=preview;const source=preview.querySelector('img'),full=root.querySelector('[data-wallpaper-dialog-image]');full.src=activeCard.dataset.wallpaperUrl;full.alt=source.alt;root.querySelector('[data-wallpaper-dialog-title]').textContent=activeCard.dataset.wallpaperTitle;const action=root.querySelector('[data-wallpaper-dialog-download]');action.href=activeCard.dataset.wallpaperUrl;root.querySelector('[data-wallpaper-original]').href=activeCard.dataset.wallpaperUrl;root.querySelector('[data-wallpaper-dialog-status]').textContent='';action.download=activeCard.dataset.wallpaperFilename+'.png';dialog.showModal();prepare(activeCard);return;}
        const control=e.target.closest('[data-wallpaper-download],[data-wallpaper-dialog-download]');if(control&&window.fetch&&window.URL?.createObjectURL){e.preventDefault();const card=control.closest('[data-wallpaper-card]')||activeCard;if(card)download(card,control);}
        if(e.target.closest('[data-wallpaper-close]'))close();
      });
      dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
    };
    const boot=()=>document.querySelectorAll('[data-n-wallpapers]').forEach(init);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();document.addEventListener('shopify:section:load',boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
